const React = require('react')

import {
  Button,
  Popover,
} from 'react-bootstrap'

export default class YearPopover extends React.Component {
  render() {
    return (
       <Popover
        id="year-popover"
        placement="bottom"
        positionTop={30}
        positionLeft={60}
        title={`The year ${this.props.year} has been selected for you`}
      >
        <p>
          The year {this.props.year} has been selected based on your VLE settings.
        </p>
        <p>
          Change or reset this filter to search other sites!
        </p>
        <div>
          <Button
            bsStyle='primary'
            onClick={this.props.onClose}
          >
            OK!
          </Button>
        </div>
      </Popover>
    )
  }
}